// 离线队列：在网络不可用或接口失败时缓存待同步的后端操作
const STORAGE_KEY = "pendingActions";
const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

function readQueue() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

function writeQueue(q) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(q)); } catch (e) { console.warn('保存 pendingActions 失败', e); }
}

export function enqueuePendingAction(action) {
  const q = readQueue();
  q.push({ id: Date.now() + Math.random(), ts: Date.now(), ...action });
  writeQueue(q);
}

export function getPendingActions() {
  return readQueue();
}

export function clearPendingAction(id) {
  const q = readQueue().filter(a => a.id !== id);
  writeQueue(q);
}

async function sendAction(action) {
  try {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
    const res = await fetch(`${API_BASE_URL}${action.url}`, {
      method: action.method || 'POST',
      headers,
      body: action.body ? JSON.stringify(action.body) : undefined,
    });
    if (res.ok) return true;
    // 如果是 401，移除 token 并不再重试此时机
    if (res.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('isLoggedIn');
    }
    return false;
  } catch (err) {
    // 网络错误，返回 false 表示未发送
    return false;
  }
}

export async function processPendingQueue() {
  const q = readQueue();
  if (!q || q.length === 0) return 0;
  let processed = 0;
  for (const action of q) {
    const ok = await sendAction(action);
    if (ok) {
      clearPendingAction(action.id);
      processed++;
    } else {
      // 如果发送失败（网络问题），停止循环，稍后再试
      break;
    }
  }
  return processed;
}

let _interval = null;
export function startPendingQueueProcessor(intervalMs = 15000) {
  if (_interval) return;
  _interval = setInterval(() => {
    if (navigator.onLine) {
      processPendingQueue().catch(e => console.warn('处理 pendingActions 异常', e));
    }
  }, intervalMs);
  // 立即尝试一次
  if (navigator.onLine) processPendingQueue().catch(e => console.warn('处理 pendingActions 异常', e));
}

export function stopPendingQueueProcessor() {
  if (_interval) clearInterval(_interval);
  _interval = null;
}
